import { SuppressKeyboardEventParams } from 'ag-grid-community';

/**
 * This allows MUI Autocomplete to handle option selection instead of AG Grid
 * closing the editor prematurely.
 *
 * Apply this to columns using singleSelect, multiSelect, or freeLabels renderers.
 */
export function suppressAutocompleteKeyboardEvents(params: SuppressKeyboardEventParams): boolean {
  if (!params.editing) {
    return false;
  }
  return params.event.key === 'Enter';
}
